const deckReducer = (state = [], _) => {
  return state;
};

export default deckReducer;
